const translations = {
  common: {
    login: "Log ind",
    logout: "Log ud",
    email: "Email",
    password: "Adgangskode",
    dashboard: "Dashboard",
    profile: "Profil",
    settings: "Indstillinger",
    language: "Sprog",
    training: "Træning"
  },
  navbar: {
    appName: "Voice Victor"
  },
  dashboard: {
    authority: "Autoritet",
    pitchVariation: "Tonevariation",
    speechRate: "Energy Variation",
    keyMetrics: "Nøgletal",
    improvementPoints: "Forbedringspunkter",
    companyMetrics: "Virksomhedsmetrikker",
    leaderboard: "Rangliste",
    managementDashboard: "Management Dashboard",
    teamOverview: "Medarbejdere",
    filter: "Filter",
    filterTeam: "Filtrer medarbejdere",
    voiceScoreRange: "Voice Score",
    showFollowedAgents: "Vis kun fulgte medarbejdere",
    resetFilters: "Nulstil filtre",
    agentsShown: "{{count}} medarbejdere vises",
    agent: "Medarbejder",
    voiceScore: "Voice Score",
    development: "Udvikling",
    developmentOverTime: "Udvikling over tid",
    actions: "Handlinger",
    positive: "Positiv",
    stable: "Stabil",
    declining: "Faldende",
    following: "Følger",
    follow: "Følg",
    overview: "Oversigt",
    backToOverview: "Tilbage til oversigt",
    talkRatio: "Talk ratio",
    na: "N/A",
    tr: "TR",
    avgDuration: "Gns. Varighed",
    avgCallDuration: "Gennemsnitlig opkaldstid",
    competenceProfile: "Kompetenceprofil",
    yourVoiceProfile: "Din stemmeprofil",
    insightAndImprovement: "Indblik & Forbedring",
    highPriority: "Høj prioritet",
    mediumPriority: "Medium prioritet",
    lowPriority: "Lav prioritet",
    notifications: "Notifikationer",
    notificationsComingSoon: "Notifikationscenter kommer snart...",
    selectCategory: "Vælg en kategori fra menuen",
    agents: "Medarbejdere",
    alerts: "Alerts",
    noAgentsMatchFilters: "Ingen medarbejdere matcher de valgte filtre",
    moreListening: "Mere lytning",
    moreTalking: "Mere tale",
    improvementOpportunities: "Forbedringsmuligheder",
    best30Seconds: "Bedste 30 sekunder (seneste 10 opkald)",
    worst30Seconds: "Værste 30 sekunder (seneste 10 opkald)",
    seeAllImprovements: "Se alle forbedringsmuligheder",
    comingSoon: "Kommer snart",
    featureNotAvailable: "Denne funktion er ikke tilgængelig endnu"
  },
  race: {
    title: "Race",
    raceTo100: "Race til 100",
    topScore: "Top Score",
    biggestImprovement: "Største Forbedring",
    score: "Score",
    from: "Fra",
    challengeColleague: "Udfordr en Kollega",
    chooseColleague: "Vælg en kollega at udfordre til at forbedre deres voice score:",
    challenge: "Udfordr",
    noUserData: "Ingen brugerdata fundet. Tilføj nogle voice scores for at se race-data.",
    yourPosition: "Din placering: #{{rank}} af {{total}} deltagere",
    voiceScore: "Voice Score",
    improvement: "Forbedring",
    raceTab: "Race",
    improvementTab: "Forbedring",
    challengeTab: "Udfordring"
  },
  login: {
    title: "Voice Victor - Login",
    invalidRole: "Ugyldig brugerrolle",
    profileNotFound: "Brugerprofil ikke fundet. Kontakt venligst administratoren.",
    failedToFetch: "Kunne ikke hente brugerprofil. Sikkerhedsregler kan være forkert konfigureret.",
    invalidCredentials: "Forkert email eller adgangskode.",
    userNotFound: "Ingen bruger fundet med denne email.",
    wrongPassword: "Forkert adgangskode.",
    tooManyAttempts: "For mange mislykkede forsøg. Prøv igen senere."
  },
  errorMessages: {
    loginFailed: "Fejl ved login: "
  },
  questions: {
    sectionTitle: "Spørgsmål & Delaccepter",
    hvQuestions: "HV-Spørgsmål",
    hvQuestionsDescription: "Spørgsmål, der afdækker hvem, hvad, hvornår, hvor, hvorfor og hvordan for at forstå kundens behov og situation.",
    partialAccepts: "Delaccepter",
    partialAcceptsDescription: "Spørgsmål, der søger delvise accept eller trinvise aftaler.",
    moreQuestions: "flere spørgsmål"
  },
  training: {
    title: "Voice Træning",
    description: "Øv din kommunikation med vores AI-træningsassistent",
    startTraining: "Start Træning",
    stopTraining: "Stop Træning",
    starting: "Starter...",
    stopping: "Stopper...",
    connecting: "Forbinder til træningssession...",
    connected: "Forbundet",
    agentConnected: "AI-assistent tilsluttet",
    browserNotSupported: "Din browser understøtter ikke alle nødvendige funktioner til træning",
    selectScenario: "Vælg Scenario",
    howItWorks: "Sådan fungerer det",
    step1: "Vælg et træningsscenario fra dropdown menuen",
    step2: "Klik på 'Start Træning' for at påbegynde sessionen",
    step3: "Giv adgang til din mikrofon når browseren beder om det",
    step4: "Samtalen optages automatisk og uploades til Firebase efter sessionen"
  }
};

export default translations; 